import {
    Component,
    OnInit,
    ViewChild,
    EventEmitter,
    Input
  } from '@angular/core';
  import {
    MatTableDataSource,
    MatPaginator,
    MatSort,
    MatDialog,
    MatTable,
    PageEvent
  } from '@angular/material';
  import { UserService } from '../_service/user.service';
  import { AlertifyService } from '../_service/alertify.service';
  import { SelectionModel } from '@angular/cdk/collections';
  import { UpdateUserComponent } from './update-user/update-user.component';
  import { ResendEmailComponent } from '../resendEmail/resendEmail.component';
  import { InviteComponent } from '../invite/invite.component';
  import { CreateUserComponent } from './create-user/create-user.component';
  import { Subject } from 'rxjs';
  import { ShowUserLocationComponent } from './user-location/showUserLocation/showUserLocation.component';
  import { takeUntil } from 'rxjs/operators';
  import { UserPermissionComponent } from './user-permission/user-permission.component';
  import { AuthService } from '../_service/auth.service';
  import { TreeComponent } from '../tree/tree.component';
  import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
  
  export class TodoItemNode {
    authorityUnitId: number;
    parentAuthorityUnitId: number;
    rootAuthorityUnitId: number;
    name: string;
    children?: TodoItemNode[];
    hasChild: boolean;
    isInLocation: boolean;
    isSuperAdmin: boolean;
    exists: boolean;
  }
  
  /** Flat to-do item node with expandable and level information */
  export class TodoItemFlatNode {
    authorityUnitId: number;
    parentAuthorityUnitId: number;
    rootAuthorityUnitId: number;
    item: string;
    level: number;
    isInLocation: boolean;
    isSuperAdmin: boolean;
    expandable: boolean;
  }
  
  @Component({
    selector: "users",
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css']
  })
  export class UsersComponent implements OnInit {
    constructor(
      private userService: UserService,
      private alertify: AlertifyService,
      private dialog: MatDialog,
      public authService: AuthService,
      public fb: FormBuilder
    ) {
      this.searchBarForm = fb.group({
        searchStringControl: new FormControl({value: '', disabled: false}, [])
      });
    }
  
    private tableDataUpdated = new EventEmitter<any>();
    unsubscribe = new Subject<void>();
  
    locationsFromResponse: any = [];
    location: TodoItemNode[] = [];
    user: any;
    confirmModal = false;
    deleteUserID: any;
    removedUser: any[] = [];
    userInformation: any = [];
  
    MyDataSource: any = [];
    userExists: any = [];
    userAdded: any = [];
    genericUserDeletionPrevented: any = [];
    selectedLocations: any = ([] = []);
    selectedSiteAdminLocations: any = ([] = []);
    selectedRequired: any = {};
  
    searchString: any;
    selectedParameter = 'searchString';
    selectedSearchParameter: any;
    value = '';
    searchBarForm: FormGroup;
  
    allUsers: any = [];
    emptyResult: any = {};
    message: any;
    errorMessage = false;
    locationCount: boolean;
    loading = false;
    isLoading = false;
    isDeleted = false;
  
    sdsUserId: any;
    sdsUserIdNumber: number;
  
    panelOpenState = false;
  
    selectedLocationCheck: any = [];
  
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  
    @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;
  
    @Input() totalCount: number;
    @Input() currentPage: number;
    @Input() itemsPerPage: number;
    @Input() totalItems: number;
    @Input() totalPages: number[];
    @Input() pageIndex: number = 0;
    @Input() pageSizeOptions: number[] = [5, 10, 20];
    @Input() pageSize: number;
    @Input() nextPage: number;
    @Input() previousPage: number;
  
    displayedColumns: string[] = [
      'firstName',
      'permissions',
      'resent/invite',
      'locations',
      'delete'
    ];
    selection = new SelectionModel<UserModel>(true, []);
  
    setLoadingState = (isLoading) => {};
  
    applyFilter(filterValue: string) {
      this.MyDataSource.filter = filterValue.trim().toLowerCase();
    }
  
    ngOnInit() {
      this.getLoggedInUsersOutSideId();
      this.disableSearchbox(); // Set initial disabled state
  
      this.sdsUserId = this.authService.decodedToken.userid;
      this.sdsUserIdNumber = +this.sdsUserId;
    }
  
    onSelectParameter(event) {
      this.selectedSearchParameter = event.value;
    }
  
    clearInputBox() {
      this.value = '';
      this.searchString = '';
      this.searchBarForm.controls['searchStringControl'].setValue('');
    }
  
    searchForUsers(selectedValue: string) {
      this.allUsers = [];
      this.searchString = selectedValue;
      this.paginator.firstPage();
      this.getAllUsers();
    }
  
      // filter by location function
      filterByLocation(filterLocationIds) {
  
        Array.from(filterLocationIds.checklistSelection._selection.entries())
        .forEach(entry => this.selectedLocationCheck = entry[0]);
  
        if (this.selectedLocationCheck.authorityUnitId !== undefined || this.selectedLocationCheck.length !== 0) {
          this.selectedLocations = filterLocationIds.checklistSelection._selection;
          this.paginator.firstPage();
          this.getAllUsers();
        } else {
          this.alertify.message('Please select a location/locations to filter');
        }
      }
  
  
    disableSearchbox() {
      if (this.selectedParameter === 'searchString') {
        this.value = '';
        this.searchString = '';
        this.searchBarForm.controls['searchStringControl'].disable();
      } else {
        this.searchBarForm.controls['searchStringControl'].enable();
      }
    }
  
    pageChanged(event: PageEvent) {
      this.totalItems = event.length;
      this.pageIndex = event.pageIndex;
      this.nextPage = event.pageSize;
      this.getAllUsers();
    }
  
    invalidSearchResultMessage(message) {
      if (message) {
        this.message = message;
      } else {
        this.message = '';
      }
    }
  
    restrictDropDownParams() {
      if (this.selectedParameter === 'emailAddress' && this.searchString === '') {
        this.alertify.message('Please enter a search parameter');
        return false;
      }
      if (this.selectedParameter === 'firstName' && this.searchString === '') {
        this.alertify.message('Please enter a search parameter');
        return false;
      }
      if (this.selectedParameter === 'lastName' && this.searchString === '') {
        this.alertify.message('Please enter a search parameter');
        return false;
      } else {
        return true;
      }
    }
  
    getAllUsers() {
      this.pageSize = this.pageSizeOptions[1];
  
      const obj: SearchUserObj = {
        emailAddress: '',
        firstName: '',
        lastName: '',
        locationId: [],
        pageNumber: null,
        pageSize: null
      };
  
      if (this.selectedSearchParameter === 'emailAddress') {
        obj.emailAddress = this.searchString.trim();
      }
  
      if (this.selectedSearchParameter === 'firstName') {
        obj.firstName = this.searchString.trim();
      }
  
      if (this.selectedSearchParameter === 'lastName') {
        obj.lastName = this.searchString.trim();
      }
  
      if (this.authService.decodedToken.role === 'Super Admin') {
        obj.locationId = [];
        for (const loc of this.selectedLocations) {
          obj.locationId.push(loc.authorityUnitId);
        }
      }
      if (this.authService.decodedToken.role === 'Site Admin') {
        obj.locationId = [];
        for (const loc of this.selectedLocations) {
          if (loc.userId === this.sdsUserIdNumber) {
            obj.locationId.push(loc.authorityUnitId);
          }
        }
      }
  
      obj.pageNumber = this.pageIndex;
      obj.pageSize = this.nextPage;
  
      if (this.restrictDropDownParams()) {
        this.isLoading = true;
        this.setLoadingState(true);
        this.errorMessage = false;
        return this.userService
          .getAllUsersByAuthority(obj)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            res => {
              this.emptyResult = res.headers.get('emptyresult');
              if (res.body) {
                this.userInformation = res.body;
                this.MyDataSource = new MatTableDataSource(this.userInformation);
                this.MyDataSource.data = res.body;
  
                // case insensitive sorting
                this.MyDataSource.sortingDataAccessor = (data, sortHeaderId) => data[sortHeaderId].toLocaleLowerCase();
  
                this.currentPage = JSON.parse(
                  res.headers.get('pagination')
                ).currentPage;
                this.itemsPerPage = JSON.parse(
                  res.headers.get('pagination')
                ).itemsPerPage;
                this.totalItems = JSON.parse(
                  res.headers.get('pagination')
                ).totalItems;
                this.totalPages = JSON.parse(
                  res.headers.get('pagination')
                ).totalPages;
  
                this.MyDataSource.sort = this.sort;
                this.isLoading = false;
                this.setLoadingState(false);
              } else if (this.emptyResult) {
                this.invalidSearchResultMessage(this.emptyResult);
                this.errorMessage = true;
                this.MyDataSource.data = [];
                this.isLoading = false;
                this.setLoadingState(false);
              }
            },
            error => {
              console.log('There was an error: ' + error);
            }
          );
      }
    }
  
    ngOnDestroy(): void {
      this.unsubscribe.next();
      this.unsubscribe.complete();
    }
  
    destroyTree() {
      console.log('Destroyed');
      this.unsubscribe.next();
      this.unsubscribe.complete();
      console.log(this.locationTree);
      this.locationTree.unsubscribe.complete();
      this.locationTree.unsubscribe.next();
      this.selectedLocations = [];
      this.selectedSiteAdminLocations = [];
      this.ngOnDestroy();
    }
  
    // check user's permission and restrict permission change
    isAdmin(permission) {
      if (this.authService.decodedToken.role === 'Super Admin') {
        if (permission === 'Super Admin') {
          return true;
        }
      }
      if (this.authService.decodedToken.role === 'Site Admin') {
        if (permission === 'Super Admin') {
          return true;
        } else {
          return false;
        }
      }
    }
  
    dontDeleteUser() {
      this.confirmModal = false;
    }
  
    removeSelectedUser(id) {
      this.confirmModal = true;
      this.deleteUserID = id;
    }
  
    deleteUser(id) {
      this.isDeleted = true;
      return this.userService.removeUser(id).subscribe(
        res => {
          // prevent non super admins from deleting generic users
          this.genericUserDeletionPrevented =  res.headers.get('accountdeletionprevented');
          if (this.genericUserDeletionPrevented) {
            this.alertify.message(this.genericUserDeletionPrevented);
            this.confirmModal = false;
            this.isDeleted = false;
          } else {
            this.alertify.success('Successfully deleted this user');
            this.confirmModal = false;
            this.searchString = '';
            this.searchBarForm.value.searchStringControl = '';
            this.searchBarForm.controls.searchStringControl.reset();
            this.selectedParameter = 'searchString';
            this.isDeleted = false;
            this.getAllUsers();
          }
        },
        error => {
          this.isDeleted = false;
          this.alertify.error('Something went wrong, please try again!');
        }
      );
    }
  
    openUserEditModalWindow(user) {
      const dialogRef = this.dialog.open(UpdateUserComponent, {
        width: '700px',
        data: {
          user: user
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getAllUsers();
      });
    }
  
    openUserPermissionModalWindow(user) {
      const dialogRef = this.dialog.open(UserPermissionComponent, {
        width: '700px',
        data: {
          user: user
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getAllUsers();
      });
    }
  
    openResendEmailConfirmation(user) {
      const dialogRef = this.dialog.open(ResendEmailComponent, {
        width: '700px',
        data: {
          user: user
        }
      });
    }
  
    openInvitationModalWindow() {
      const dialogRef = this.dialog.open(InviteComponent, {
        width: '700px'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (dialogRef.componentInstance.isModified) {
          this.getAllUsers();
        }
      });
    }
  
    openCreateInternalUser() {
      const dialogRef = this.dialog.open(CreateUserComponent, {
        width: '1000px'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (dialogRef.componentInstance.isModified) {
          this.getAllUsers();
        }
      });
    }
  
    openUserLocationModalWindow(user) {
      const dialogRef = this.dialog.open(ShowUserLocationComponent, {
        width: '700px',
        data: {
          user: user
        }
      });
    }
  
    getLoggedInUsersOutSideId() {
      return this.authService.decodedToken.nameid;
    }
  
    locations: any;
  
    assignLocation(assignLocationIds) {
      this.loading = true;
      const params = new URLSearchParams();
      this.selectedLocations = assignLocationIds.checklistSelection._selection;
  
      for (const selectedUser of this.selection.selected) {
        params.append('userOutSideId', selectedUser.userOutsideId);
      }
  
      // super admin location tree/location ID
      if (this.authService.decodedToken.role === 'Super Admin') {
        if (this.selectedLocations.length !== 0) {
          for (const location of this.selectedLocations) {
            params.append('authorityUnitIds', location.authorityUnitId);
          }
        }
      }
      // site admin location tree/location ID
      if (this.authService.decodedToken.role === 'Site Admin') {
        if (this.selectedLocations.length !== 0) {
          for (const location of this.selectedLocations) {
            if (location.userId === this.sdsUserIdNumber) {
              params.append('authorityUnitIds', location.authorityUnitId);
            }
          }
        }
      }
  
      return this.userService
        .assignUserLocation(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          res => {
            this.locations = res;
  
            this.userExists = res.headers.get('exists');
            if (this.userExists) {
              this.loading = false;
              this.alertify.message(this.userExists);
            }
  
            this.userAdded = res.headers.get('added');
            if (this.userAdded) {
              this.loading = false;
  
              // clear location tree check box/boxes
              this.selectedLocations.clear();
              this.alertify.success(this.userAdded);
            }
  
            this.selectedRequired = res.headers.get('selectedrequired');
            if (this.selectedRequired) {
              this.loading = false;
              this.alertify.message(this.selectedRequired);
            }
          },
          error => {
            this.loading = false;
            this.alertify.error('Something went wrong, please try again!');
          }
        );
    }
  
    // disables/re-enables assign button
    disableAssignButton(): boolean {
      if (
        this.locationTree.checklistSelection.hasValue() ||
        this.locationTree.itemSelected
      ) {
        return true;
      } else {
        return false;
      }
    }
  
    // deselects checked boxes and removes values
    removeSelectedCheckBoxes() {
      this.locationTree.grandChildrenAuthorityUnitId = [];
      this.locationTree.childAuthorityUnitId = [];
      this.locationTree.parentAuthorityUnitId = [];
    }
  
    public doFilter = (value: string) => {
      this.MyDataSource.filter = value.trim().toLocaleLowerCase();
    };
  
    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
      const numSelected = this.selection.selected.length;
      if (numSelected === 0) {
        return null;
      }
      const numRows = this.MyDataSource.data.length;
      return numSelected === numRows;
    }
  
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
      this.isAllSelected()
        ? this.selection.clear()
        : this.MyDataSource.data.forEach(row => this.selection.select(row));
    }
  
    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: UserModel): string {
      if (!row) {
        return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
      }
      return `${
        this.selection.isSelected(row) ? 'deselect' : 'select'
      } row ${row.position + 1}`;
    }
  
    disableLocation(node: TodoItemFlatNode): boolean {
      // disable if not in location
      if (!node.isInLocation) {
        return true;
      }
    }
  }
  
  export interface UserModel {
    firstName: string;
    lastName: string;
    isActive: boolean;
    position: number;
    permission: number;
    userOutsideId: string;
  }
  
  export interface SearchUserObj {
    emailAddress: string;
    firstName: string;
    lastName: string;
    locationId: number[];
    pageNumber: number;
    pageSize: number;
  }